import React from "react"

// Provides a section container to manage page layout.
type Props = {
  head?: React.ReactNode | null
  subhead?: React.ReactNode | null
  children: React.ReactNode
  style?: React.CSSProperties
  className?: string
  headClassName?: string
  useH1?: boolean
  id?: string
}

const Section = ({
  head,
  subhead,
  children,
  style,
  className,
  headClassName,
  useH1,
  id,
}: Props) => (
  <div className={`marketing-section ${className}`} style={style} id={id}>
    {head || subhead ? (
      <div className={`marketing-section-head ${headClassName}`}>
        {head !== null && useH1 ? (
          <h1 style={{ marginBottom: 0, fontSize: "3em" }}>{head}</h1>
        ) : (
          <h2 style={{ marginBottom: 0 }}>{head}</h2>
        )}
        {subhead && <h3>{subhead}</h3>}
      </div>
    ) : null}
    {children && children}
  </div>
)

export default Section
